import { Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from '../redux/store'
import { checkRole } from '../utils/checkRole'
import { checkFeature } from '../utils/checkFeature'
import { Roles } from '../const/permissions'
import { Features } from '../const/features'
import { ROUTES } from '../const/routes'

const AuthWrapper = ({
  children,
  requiredRoles,
  requiredFeature,
}: {
  children: JSX.Element
  requiredRoles: Roles[]
  requiredFeature?: Features
}) => {
  let location = useLocation()
  const { roles, features } = useAppSelector(state => state.user)

  if (!checkRole(roles, requiredRoles)) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  if (!!requiredFeature && !checkFeature(features, requiredFeature)) {
    return (
      <Navigate
        to={`/${ROUTES.ADMIN_BASE}/${ROUTES.PARKING_POOL_USERS}`}
        replace
      />
    )
  }

  return children
}

export default AuthWrapper
